const hasNative = !import.meta.env.SSR && "scrollRestoration" in window.history;
const initial = !import.meta.env.SSR && hasNative ? window.history.scrollRestoration : "auto";
export const data = { hasNative, initial };
